import { Fade } from "./Fade";

const steps = [
  {
    number: "01",
    title: "Automated channel integration",
    description:
      "Growth Lever connects your Meta, Google, and TikTok accounts in minutes — automatically consolidating campaigns, budgets, and performance data.",
  },
  {
    number: "02",
    title: "Growth Lever analyzes and recommends",
    description:
      "We monitor campaigns in real time to surface what to scale, pause, or optimize; and shows where capital can be deployed to maximize returns.",
  },
  {
    number: "03",
    title: "Execute with embedded capital",
    description:
      "Execute decisions instantly. Once eligibility thresholds are met, you approve capital activation — then funding is deployed alongside your budget in real time.",
  },
];

export function HowItWorks() {
  return (
    <section className="bg-white text-[hsl(222_47%_11%)] px-5 sm:px-8 md:px-10 py-20 sm:py-28">
      <div className="max-w-[1280px] mx-auto">
        <Fade>
          <p className="text-xs tracking-[0.2em] uppercase text-[hsl(217_91%_60%)] mb-4 font-medium">
            How it works
          </p>
        </Fade>
        <Fade delay={0.05}>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-[-0.02em] max-w-lg mb-14">
            From data to execution in three steps
          </h2>
        </Fade>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, i) => (
            <Fade key={step.number} delay={0.08 * i} y={16}>
              <div className="relative">
                <span className="text-5xl font-bold text-black/[0.06] leading-none block mb-4">
                  {step.number}
                </span>
                <h3 className="text-lg font-semibold mb-2">{step.title}</h3>
                <p className="text-sm text-black/50 leading-relaxed">{step.description}</p>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
}
